import { Component, OnInit, Optional, Inject } from '@angular/core';
import { ReporteService } from '@pages/cobranza/services/reporte.service';
import { Reportes } from '@pages/cobranza/interfaces/reportes';
import { Table } from 'primeng/table';
import { SsrsReportsService } from '@shared/services/SSRSreports/ssrsReports.service';
import { ReportingFilterComponent } from '@shared/components/reports/reporting-filter/reporting-filter.component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LoadingService } from '@shared/utils/loading.service';
import { SwalService } from '@shared/utils/swal.service';

export interface IReporte {
  clave: string;
  descripcion: string;
  tablaPivote: string;
}

@Component({
  selector: 'app-consulta-log',
  templateUrl: './consulta-log.component.html',
  styleUrls: ['./consulta-log.component.html']
})
export class ConsultaLogComponent implements OnInit {
  public columns = [
    { field: 'clave', header: 'Código' },
    { field: 'descripcion', header: 'Descripción' }
  ];
  public reportes: IReporte[] = [];
  public disabled: boolean = false;
  public modoActividad: boolean = false;

  constructor(
    private _reportService: ReporteService,
    private ssrsReports: SsrsReportsService,
    public dialog: MatDialog,
    public loading: LoadingService,
    private _swalService: SwalService,
    @Optional() public dialogRef: MatDialogRef<ConsultaLogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data) {
      this.modoActividad = data.modoActividad || false;
    }
  }

  ngOnInit(): void {
    this.getReports();
  }

  getReports(): void {
    const model: Reportes = {
      Que: 7,
      Tope: '100',
      Cmd: '',
      SCmd: '',
      Clave: '',
      Descripcion: '',
      TablaPivote: '',
      XmL_File: '',
      HtmL_File: '',
      XmL_Dat: '',
      Usuario: 'ADMLGB',
      Catalogo: '',
      Master: '',
      TipoCampos: '',
      Modulo: '95', // Módulo específico para consulta de log
      Separador: ''
    };

    this._reportService.getAllReports(model).subscribe({
      next: (res: any) => {
        if (Array.isArray(res)) {
          this.reportes = res.map((item) => ({
            clave: item.clave || '',
            descripcion: item.descripcion || '',
            tablaPivote: item.tablaPivote || ''
          }));
        } else {
          this.reportes = [];
        }
      },
      error: (error) => {
        console.error('Error al cargar reportes:', error);
        this.reportes = [];
      }
    });
  }

  getConfReport(report: IReporte): void {
    let format: 'PDF' | 'CSV' = null;
    this.loading.show();
    if (report.tablaPivote.includes('RSO')) {
      format = 'PDF';
    } else if (report.tablaPivote.includes('PROCEDURE')) {
      format = 'CSV';
    }
    this.ssrsReports.GetConfReport(report.clave).subscribe({
      next: (res) => {
        if (res.success) {
          this.loading.hide();
          const dialogRef = this.dialog.open(ReportingFilterComponent, {
            data: {
              report: res.data,
              typeFile: format,
              reportId: report.clave,
              reportName: report.descripcion
            }
          });
          dialogRef.afterClosed().subscribe((confirmresult) => {
            if (confirmresult) {
              this.Close();
            }
          });
        } else {
          this.loading.hide();
          console.log(res);
          this._swalService.error('Ocurrio un error al traer la configuracion del reporte.');
        }
      },
      error: (err) => {
        console.log(err);
      }
    });
  }

  //Link reportes
  openWindow(report: string): void {
    let url =
      'https://credisystem.datascoring.co/eCrediUtilities/Reports/wfmReportViewer.aspx?sUsuario=' +
      sessionStorage.getItem('user') +
      '&sNumClte=&iTipoRef=0&iOdbcRef=0&iMulOdbc=1&sCompanyId=COVI&sIdCliente=&iAccion=1&sReporte=';
    window.open(url + report, '_blank');
    this.Close();
  }

  // Método para cerrar el diálogo
  Close(): void {
    if (this.data?.onClose) {
      this.data.onClose();
    }

    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }
} 